import { render } from "./WorkdayIcon.vue?vue&type=template&id=3834121c"
import script from "./WorkdayIcon.vue?vue&type=script&lang=js"
export * from "./WorkdayIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__